





















































































import { computed, defineComponent } from '@vue/composition-api';
import { useRender } from '../hooks/useRender';
import { getFileType } from './utils';

//引入相关样式
import '@vue-office/docx/lib/index.css';
import '@vue-office/excel/lib/index.css';

const FILE_SIZE_LIMITS: Record<string, number> = {
  pdf: 50 * 1024 * 1024,
  docx: 30 * 1024 * 1024,
  excel: 20 * 1024 * 1024,
  ppt: 30 * 1024 * 1024,
  markdown: 10 * 1024 * 1024,
  txt: 10 * 1024 * 1024
};

function formatSize(bytes?: number): string {
  if (!bytes) {
    return '';
  }
  if (bytes < 1024) {
    return `${bytes}B`;
  }
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)}KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)}MB`;
}

export default defineComponent({
  components: {
    VueOfficeDocx: () => import('@vue-office/docx'),
    VueOfficeExcel: () => import('@vue-office/excel'),
    VueOfficePdf: () => import('@vue-office/pdf'),
    VueOfficePptx: () => import('@vue-office/pptx'),
    MarkdownPreview: () => import('./MarkdownPreview.vue'),
    TxtPreview: () => import('./TxtPreview.vue')
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: undefined
    }
  },
  setup(props) {
    const { closePreviewDrawer, showDrawer } = useRender();

    const show = computed(() => showDrawer.value);

    const onClose = () => {
      closePreviewDrawer(true);
    };

    const rendered = () => {};
    const currentName = computed(() => props.name);
    const currentUrl = computed(() => props.url);
    const fileType = computed(() => getFileType(props.name || props.url));

    const isOversized = computed(() => {
      if (props.size === undefined) {
        return false;
      }
      const limit = FILE_SIZE_LIMITS[fileType.value];
      if (!limit) {
        return false;
      }
      if (fileType.value === 'pdf') {
        return false;
      }
      return props.size > limit;
    });

    const pdfOptions = computed(() => {
      if (fileType.value !== 'pdf' || props.size === undefined) {
        return undefined;
      }
      const limit = FILE_SIZE_LIMITS.pdf;
      return props.size > limit ? { lazy: true } : undefined;
    });

    return {
      onClose,
      show,
      currentName,
      currentUrl,
      fileType,
      isOversized,
      pdfOptions,
      rendered,
      formatSize
    };
  }
});
